import {
  BaseEdge,
  EdgeLabelRenderer,
  getSmoothStepPath,
  useReactFlow,
  type EdgeProps,
} from '@xyflow/react';
import { X } from 'lucide-react';
import { COLORE_RAMO, NOME_RAMO } from '../../../lib/email/disegnoSequenza';

/**
 * La freccia fra due caselle: ad angoli, colorata come il ramo da cui esce
 * (si'/no di una domanda, arrivata/scaduto di un'attesa di una lista).
 * Quando la scegli compare la crocetta per toglierla, cosi' non serve sapere
 * che si cancella col tasto indietro.
 */
export function FrecciaSequenza({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  sourceHandleId,
  selected,
  deletable,
  markerEnd,
}: EdgeProps) {
  const { deleteElements } = useReactFlow();
  const [percorso, etichettaX, etichettaY] = getSmoothStepPath({
    sourceX,
    sourceY,
    sourcePosition,
    targetX,
    targetY,
    targetPosition,
    borderRadius: 14,
    offset: 20,
  });

  const ramo = sourceHandleId && NOME_RAMO[sourceHandleId] ? sourceHandleId : null;
  const colore = COLORE_RAMO[ramo ?? 'out'];
  const mostraCrocetta = selected && deletable !== false;

  return (
    <>
      <BaseEdge
        id={id}
        path={percorso}
        markerEnd={markerEnd}
        interactionWidth={24}
        style={{ stroke: colore, strokeWidth: selected ? 2.5 : 1.75 }}
      />
      {(ramo || mostraCrocetta) && (
        <EdgeLabelRenderer>
          <div
            className="nodrag nopan absolute flex items-center gap-1"
            style={{
              transform: `translate(-50%, -50%) translate(${etichettaX}px, ${etichettaY}px)`,
              pointerEvents: 'all',
            }}
          >
            {ramo && (
              <span
                className="px-1.5 py-0.5 text-[10px] font-semibold uppercase tracking-wide bg-white border rounded-sm"
                style={{ color: colore, borderColor: colore }}
              >
                {NOME_RAMO[ramo]}
              </span>
            )}
            {mostraCrocetta && (
              <button
                type="button"
                onClick={() => deleteElements({ edges: [{ id }] })}
                className="w-5 h-5 flex items-center justify-center rounded-full bg-neutral-900 text-white shadow hover:bg-red-600 transition-colors"
                aria-label="Togli questa freccia"
                title="Togli questa freccia"
              >
                <X className="w-3 h-3" />
              </button>
            )}
          </div>
        </EdgeLabelRenderer>
      )}
    </>
  );
}
